import { render, staticRenderFns } from "./RepairsAndProjectsNear.vue?vue&type=template&id=4b2d2196&"
import script from "./RepairsAndProjectsNear.vue?vue&type=script&lang=ts&"
export * from "./RepairsAndProjectsNear.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports